// Centralized authentication utilities
const TOKEN_KEY = 'token';

// Safely decode JWT payload with validation
export const decodeToken = (token) => {
  if (!token) return null;
  
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const payload = JSON.parse(atob(parts[1]));
    
    // Check if token is expired
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      return null;
    }
    
    return payload;
  } catch (error) {
    console.warn('Invalid token format');
    return null;
  }
};

// Check if user is admin
export const isAdmin = (token) => {
  const payload = decodeToken(token);
  return payload?.is_admin === 1;
};

// Check if user is approved
export const isApproved = (token) => {
  const payload = decodeToken(token);
  return payload?.approved === true || payload?.approved === 1;
};

// Get user ID from token
export const getUserId = (token) => {
  const payload = decodeToken(token);
  return payload?.id;
};

// Get username from token
export const getUsername = (token) => {
  const payload = decodeToken(token);
  return payload?.username;
};

// Check if token is valid (not expired and properly formatted)
export const isValidToken = (token) => {
  return decodeToken(token) !== null;
};

// Token storage utilities
export const getStoredToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setStoredToken = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  } else {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export const removeStoredToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// Initialize token state - validates stored token
export const initializeAuth = () => {
  const token = getStoredToken();
  if (token && !isValidToken(token)) {
    removeStoredToken();
    return null;
  }
  return token;
}; 